"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var scale_1 = require("@antv/scale");
exports.Scale = scale_1.Scale;
//# sourceMappingURL=interface.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_attr@0.3.2@@antv/attr/lib/interface.js
// module id = 3Uzm
// module chunks = 14